import { AxiosInstance, AxiosResponse } from 'axios';
import config from '../../config';
import { IPageableResponse, ICriteria, CategoryDataType } from '@recone/models';

const GET_CRITERIAS_PATH = 'criteria/list';
const GET_CRITERIA_PATH = 'criteria/';

export const getCriterias = (
  axiosInstance: AxiosInstance,
  page = 0,
  limit = config.service.QUERY_DEFAULT_LIMIT
): Promise<AxiosResponse<IPageableResponse<ICriteria>>> =>
  axiosInstance.get(`${config.service.BASE_URL}/${GET_CRITERIAS_PATH}?page=${page}&limit=${limit}`);

export const getCriteria = (axiosInstance: AxiosInstance, criteriaId: string): Promise<AxiosResponse<ICriteria>> =>
  axiosInstance.get(`${config.service.BASE_URL}/${GET_CRITERIA_PATH}${criteriaId}`);

export const deleteCriteria = (axiosInstance: AxiosInstance, criteriaId: string): Promise<AxiosResponse<ICriteria>> =>
  axiosInstance.delete(`${config.service.BASE_URL}/${GET_CRITERIA_PATH}${criteriaId}`);

export const updateCriteria = (
  axiosInstance: AxiosInstance,
  criteriaId: string,
  criteria: Partial<ICriteria>
): Promise<AxiosResponse<ICriteria>> =>
  axiosInstance.patch(`${config.service.BASE_URL}/${GET_CRITERIA_PATH}${criteriaId}`, { criteria: criteria });

export const createCriteria = (
  axiosInstance: AxiosInstance,
  name: string,
  description?: string,
  filters?: string | CategoryDataType[]
): Promise<AxiosResponse<ICriteria>> =>
  axiosInstance.post(`${config.service.BASE_URL}/${GET_CRITERIA_PATH}`, { criteria: { name, description, filters } });
